import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { Select } from 'tea-component';
import { languageSelectMap, singleLanguageSelectOptions } from '../../constant';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import './index.scss'; 

const SingleTranslateSelect = (props: any) => {
  const { onChange, key, style, defaultValue } = props;
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [languageChoose, setLanguageChoose] = useState(defaultValue);

  const languageButton = () => {
    return (
      <div className="dbo-select-button">
        <SvgIcon type="translate" className="dbo-select-button-icon" />
        <div className="tea-text-overflow">
          {formatMessage({
            id: languageSelectMap?.[languageChoose || 'origin'],
          })}
        </div>
      </div>
    );
  };

  useEffect(() => {
    setLanguageChoose(defaultValue);
  }, [defaultValue]);

  return (
    <Select
      className="select-item dbo-translate-select"
      size="m"
      boxClassName="select-translate-box-wrapper"
      matchButtonWidth
      appearance="button"
      value={languageChoose}
      onChange={(value) => {
        setLanguageChoose(value);
        onChange?.(key, value);
      }}
      options={formatOptionsMessage(singleLanguageSelectOptions)}
      button={languageButton}
      footer={
        <div style={{ textAlign: 'left', maxWidth: 204 }}>
          {formatMessage({
            id: 'From GPT-Translator. Powered by DataBrain NLP Team',
          })}
        </div>
      }
      style={{ ...(style || {}) }}
    />
  );
};

export default SingleTranslateSelect;
